import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { isEqual } from 'lodash';
import { computed, inject, ComputedRef } from 'vue';

import { props as propsDefinition } from './option.shared';
import { StSelectOption } from './option.styled';
import { SelectOption, SelectProvide } from '../select.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkOption',
  props: propsDefinition,
  setup(__props) {

const props = __props


const selectInstance = inject('select') as SelectProvide;

const getCurrentOption: ComputedRef<SelectOption> = computed(() => selectInstance.options.value
  .find((o, index) => o._id === `${ JSON.stringify(props.label).toLowerCase() }_${ JSON.stringify(props.value) }`) as SelectOption);

const getCurrentOptionIndex = computed(() => selectInstance.filteredOptions.value.findIndex(o => isEqual(o, getCurrentOption.value)));

const isActive = computed(() => selectInstance.activeOptions.value.includes(getCurrentOption.value));
const isVisible = computed(() => selectInstance.filteredOptions.value.includes(getCurrentOption.value));
const isHighlighted = computed(() => selectInstance.highlightedOptionIndex.value === getCurrentOptionIndex.value);

const toggleActiveOption = () => selectInstance.toggleActiveOption(getCurrentOption.value);
const setHighlightedOptionIndex = () => selectInstance.setHighlightedOptionIndex(getCurrentOptionIndex.value);

const handleClick = () => toggleActiveOption();

return (_ctx: any,_cache: any) => {
  return (_unref(isVisible))
    ? (_openBlock(), _createBlock(_unref(StSelectOption), _mergeProps({
        key: 0,
        class: ["nk-option", {
      'is-active': _unref(isActive),
      'is-highlight': _unref(isHighlighted),
    }]
      }, _ctx.$attrs, {
        onClick: handleClick,
        onMouseenter: setHighlightedOptionIndex,
        onFocus: _cache[0] || (_cache[0] = () => null)
      }), {
        default: _withCtx(() => [
          (_ctx.$slots.default)
            ? _renderSlot(_ctx.$slots, "default", { key: 0 })
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(props.label), 1)
              ], 64))
        ]),
        _: 3
      }, 16, ["class"]))
    : _createCommentVNode("", true)
}
}

})